import { combineReducers } from "redux";

interface OnboardingPayload {
    subjectIsLoaded?: boolean;
    itemId?: any;
    subject?: any;
    consent?: any;
}

export type OnboardingAction =
    | { type: "SEARCH_SUBJECTS_START" }
    | { type: "SEARCH_SUBJECTS_SUCCESS"; payload: OnboardingPayload }
    | { type: "SEARCH_SUBJECTS_ERROR" }
    | { type: "FORCE_ONBOARDING" }
    | { type: "REMOVE_FORCE_ONBOARDING" };

interface OnboardingState {
    subjectIsLoaded: boolean;
    isGettingSubject: boolean;
    forceOnboarding?: boolean;
    itemId?: any;
    subject?: any;
    consent?: any;
}

const initialState: OnboardingState = {
    subjectIsLoaded: false,
    isGettingSubject: false,
    forceOnboarding: false,
    itemId: "",
    subject: {},
    consent: {},
};

const subjectIsLoaded = (
    state = initialState.subjectIsLoaded,
    action: OnboardingAction,
) => {
    switch (action.type) {
        case "SEARCH_SUBJECTS_START":
            return false;
        case "SEARCH_SUBJECTS_SUCCESS":
            return action.payload?.subject?.has_id_card;
        case "SEARCH_SUBJECTS_ERROR":
            return false;
        default:
            return state;
    }
};

const isGettingSubject = (
    state = initialState.isGettingSubject,
    action: OnboardingAction,
) => {
    switch (action.type) {
        case "SEARCH_SUBJECTS_START":
            return true;
        case "SEARCH_SUBJECTS_SUCCESS":
            return false;
        case "SEARCH_SUBJECTS_ERROR":
            return false;
        default:
            return state;
    }
};

const forceOnboarding = (
    state = initialState.forceOnboarding,
    action: OnboardingAction,
) => {
    switch (action.type) {
        case "FORCE_ONBOARDING":
            return true;
        case "REMOVE_FORCE_ONBOARDING":
            return false;
        default:
            return state;
    }
};

const itemId = (state = initialState.itemId, action: OnboardingAction) => {
    switch (action.type) {
        case "SEARCH_SUBJECTS_START":
            return "";
        case "SEARCH_SUBJECTS_SUCCESS":
            return action.payload?.itemId;
        case "SEARCH_SUBJECTS_ERROR":
            return "";
        default:
            return state;
    }
};

const subject = (state = initialState.subject, action: OnboardingAction) => {
    switch (action.type) {
        case "SEARCH_SUBJECTS_START":
            return "";
        case "SEARCH_SUBJECTS_SUCCESS":
            return action.payload?.subject;
        case "SEARCH_SUBJECTS_ERROR":
            return "";
        default:
            return state;
    }
};

const consent = (state = initialState.consent, action: OnboardingAction) => {
    switch (action.type) {
        case "SEARCH_SUBJECTS_START":
            return "";
        case "SEARCH_SUBJECTS_SUCCESS":
            return action.payload?.consent;
        case "SEARCH_SUBJECTS_ERROR":
            return "";
        default:
            return state;
    }
};

const onboarding = combineReducers({
    subjectIsLoaded,
    isGettingSubject,
    forceOnboarding,
    itemId,
    subject,
    consent,
});

export default onboarding;
